// removed by extract-text-webpack-plugin
module.exports = {"component":"_2cC-5UT3pWnjksmzWcm5-r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/Scheduling/Calendar/DateRange.css
// module id = 1427
// module chunks = 0